import sortBy from 'lodash/sortBy'
import { ReactNode } from 'react'
import { SortableItem } from 'components/lists'

interface IConnection<Node> {
    edges: {
        node: Node
    }[]
}
export const getNodes = <Node=any>(connection: IConnection<Node>): Node[] => (
    connection?.edges?.map((e) => e?.node) || []
)

export const getFirstNode = <Node=any>(connection: IConnection<Node>): Node => (
    getNodes(connection).find((node) => node)
)

export const convertDataForSortableList = <Node=any>(
    nodes: Node[], renderItem: (node: Node) => ReactNode,
    orderField='order',
    renderBody?: (node: Node) => ReactNode,
): SortableItem[] => {
    const sortedNodes = sortBy(nodes, orderField)
    return sortedNodes.map((node: any) => ({
        id: node?.id,
        order: node?.[orderField],
        renderItem: () => renderItem(node),
        renderBody: () => renderBody && renderBody(node)
    }))
}
